import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import {
  AssistantConfirmPayload,
  AssistantConfirmResponse,
  AssistantStartResponse,
  RebookingSuggestionResponse,
} from "../models/assistant.model";

@Injectable({
  providedIn: "root",
})
export class AssistantBookingService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  start(
    prompt: string,
    location?: string | null,
  ): Observable<AssistantStartResponse> {
    return this.http.post<AssistantStartResponse>(
      `${this.apiUrl}/assistant/public/booking/start/`,
      {
        prompt,
        location,
      },
    );
  }

  refine(
    sessionId: string,
    prompt: string,
  ): Observable<AssistantStartResponse> {
    return this.http.post<AssistantStartResponse>(
      `${this.apiUrl}/assistant/public/booking/refine/`,
      {
        session_id: sessionId,
        prompt,
      },
    );
  }

  confirmBooking(
    payload: AssistantConfirmPayload,
  ): Observable<AssistantConfirmResponse> {
    return this.http.post<AssistantConfirmResponse>(
      `${this.apiUrl}/assistant/customer/booking/confirm/`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  getRebookingSuggestions(): Observable<RebookingSuggestionResponse> {
    return this.http.get<RebookingSuggestionResponse>(
      `${this.apiUrl}/assistant/customer/rebook-suggestions/`,
      {
        withCredentials: true,
      },
    );
  }
}
